import React from 'react';
import isNil from 'lodash/isNil';
import * as d3Axis from 'd3-axis';
import {select} from 'd3-selection';

/**
 * A singular Axis, draws ticks, tick marks, labels
 *
 * TODO move this into src/charts (properly)
 */
export default class Axis extends React.Component {
  componentDidMount() {
    this.renderAxis();
  }

  componentDidUpdate() {
    this.renderAxis();
  }

  renderAxis() {
    const {tickSizeInner = 5, tickSizeOuter = -20} = this.props;

    const axisType = `axis${this.props.orient}`;
    const axis = d3Axis[axisType]()
      .scale(this.props.scale)
      .tickSize(tickSizeInner, tickSizeOuter)
      .tickPadding([this.props.tickPadding || 8])
      .ticks(this.props.ticks)
      .tickValues(this.props.tickValues)
      .tickFormat(this.props.tickFormat);

    const g = select(this.axisElement).call(axis);

    if (!isNil(this.props.textXAdjust)) {
      g.selectAll('text').style('text-anchor', 'start').attr('x', this.props.textXAdjust);
    }
  }

  render() {
    return (
      <g
        className={`Axis Axis-${this.props.orient}`}
        ref={el => {
          this.axisElement = el;
        }}
        transform={this.props.translate}
      />
    );
  }
}
